@@ -0,0 +1,78 @@
<template>
  <material-card
    :title="$t('components.redmine.title')"
    icon="mdi-tag-heart-outline"
  >
    <pbas-data-table
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      @error="error = $event"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      fileNamePrefix="redmine"
      :identifier="selectedPlan ? `redmine${selectedPlan.Id}` : 'myRedmine'"
      :noSearch="true"
    ></pbas-data-table>
    <redmine-form-dialog
      @close="
        dialogs.edit = false;
        item = null;
      "
      @success="
        dialogs.edit = false;
        message = $event;
        snackbar = true;
        $refs.table.getDataAsync();
        item = null;
      "
      :model="dialogs.edit"
      :item="item"
      :redmineKey="redmineKey"
      :redmineProject="redmineProject"
      :users="users"
      :trackers="trackers"
      :statuses="statuses"
      :categories="categories"
      :sources="sources"
    />
    <redmine-form-dialog
      @close="
        dialogs.add = false;
        item = null;
      "
      @success="
        dialogs.add = false;
        message = $event;
        snackbar = true;
        $refs.table.getDataAsync();
        item = null;
      "
      :model="dialogs.add"
      :item="item"
      :redmineKey="redmineKey"
      :redmineProject="redmineProject"
      :users="users"
      :trackers="trackers"
      :statuses="statuses"
      :categories="categories"
      :sources="sources"
    />
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card :title="deleteTitle" :color="$vuetify.theme.themes.light.error" icon="delete">
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { RedmineProvider } from "pbas-vue-components";
import getHeaders from "@/headers/Redmine";
import ErrorHandler from "@/components/ErrorHandler";
import RedmineFormDialog from "@/components/Redmine/RedmineFormDialog";
import SettingsService from "@/services/settings.service.js";
export default {
  components: {
    ErrorHandler,
    RedmineFormDialog,
  },
  props: [
    "memberIdentityId",
    "planIdentityId",
    "redmineUserId",
    "memberCertificate",
    "planName",
  ],
  data() {
    return {
      redmineKey: "efb9a154627034173c95a2593561d535de9dd0cc",
      redmineProject: "drawbridge-integration",
      redmineProjectId: 32,
      redmineNormalPriority: {
        id: 2,
        name: "Normal",
      },
      redmineUser: {
        id: 27,
      },
      error: null,
      provider: undefined,
      dialogs: {
        add: false,
        edit: false,
        delete: false,
      },
      item: null,
      selected: [],
      deleteTitle: "",
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (items) => {
            this.selected = items;
            this.deleteTitle = this.$t(
              "components.benefits.benefits_table.delete_selected_benefits"
            );
            this.dialogs.delete = true;
          },
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => {
            console.log(this.memberIdentityId, this.planIdentityId);
            this.item = {
              project: {
                id: this.redmineProjectId,
                name: this.redmineProject,
              },
              priority: this.redmineNormalPriority,
              author: this.redmineUser,
              status: this.statuses.filter((o) => o.name === "New")[0],
            };
            if (this.memberIdentityId) {
              this.item.custom_fields = [
                {
                  attr: {
                    id: SettingsService.settings.RedmineMemberIdField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.memberIdentityId,
                  },
                },
                {
                  attr: {
                    id: SettingsService.settings.RedmineMemberCertificateField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.memberCertificate,
                  },
                },
                {
                  attr: {
                    id: SettingsService.settings.RedminePlanIdField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.planIdentityId,
                  },
                },
                {
                  attr: {
                    id: SettingsService.settings.RedminePlanNameField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.planName,
                  },
                },
              ];
            }
            else if (this.planIdentityId) {
              this.item.custom_fields = [
                {
                  attr: {
                    id: SettingsService.settings.RedminePlanIdField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.planIdentityId,
                  },
                },
                {
                  attr: {
                    id: SettingsService.settings.RedminePlanNameField.replace(
                      "cf_",
                      ""
                    ),
                  },
                  custom_field: {
                    value: this.planName,
                  },
                },
              ];
            }
            this.dialogs.add = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: async (item) => {
            try {
              this.item = (
                await this.getIssue({
                  id: item.id,
                  key: this.redmineKey,
                })
              ).data.issue;
              this.dialogs.edit = true;
            } catch (error) {
              this.error = error;
            }
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.item = item;
            this.deleteTitle = this.$t("components.redmine.delete_issue_{0}", [
              item.id,
            ]);
            this.dialogs.delete = true;
          },
        },
      ],
      users: [],
      trackers: [],
      statuses: [],
      categories:[],
      sources:[]
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    options: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("redmine", [
      "getIssue",
      "deleteIssue",
      "getUsers",
      "getTrackers",
      "getStatuses",
      "getCustomFields"
    ]),
    async loadData() {
      try {
        this.users = (
          await this.getUsers({
            key: this.redmineKey,
            project: this.redmineProject,
          })
        ).data.memberships.map((o) => o.user);

        this.trackers = (
          await this.getTrackers({
            key: this.redmineKey,
          })
        ).data.trackers;

        this.statuses = (
          await this.getStatuses({
            key: this.redmineKey,
          })
        ).data.issue_statuses;

        const cf = (
          await this.getCustomFields({
            key: this.redmineKey,
          })
        ).data.custom_fields;

        this.categories = cf.filter(o=>o.id === 14)[0].possible_values;
        this.sources = cf.filter(o=>o.id === 15)[0].possible_values;
        const url = SettingsService.settings.RedmineURL + "issues.json";
        const headers = getHeaders(
          this.trackers,
          this.statuses,
          this.users,
          this.memberIdentityId === null || this.memberIdentityId === undefined,
          (this.planIdentityId === null || this.planIdentityId === undefined) && (this.memberIdentityId === null || this.memberIdentityId === undefined)
        );
        this.provider = new RedmineProvider(
          this.$axiosHttp,
          url,
          headers,
          "issues",
          this.redmineKey
        );
        const filters = [
          `project_id=${SettingsService.settings.RedmineProjectId}`,
        ];

        if (this.memberIdentityId) {
          filters.push(
            `${SettingsService.settings.RedmineMemberIdField}=${this.memberIdentityId}`
          );
        }
        if (this.planIdentityId) {
          filters.push(
            `${SettingsService.settings.RedminePlanIdField}=${this.planIdentityId}`
          );
        }
        if (this.redmineUserId) {
          filters.push(`assigned_to_id=${this.redmineUserId}`);
        }
        this.provider.filter = filters.join("&");
      } catch (error) {
        this.error = error;
      }

      // this.provider.filter=`project_id=${this.redmineProjectId}&status_id=*`;
    },
    async tryDelete() {
      try {
        this.saving = true;
        await this.deleteIssue({
          key: this.redmineKey,
          id: this.item.id,
        });
        this.dialogs.delete = false;
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
